import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-136">
      {/* Background glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#00d4ff]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-137"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-138">
        {/* The Unique Mechanism */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-139">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#00d4ff]/10 border border-[#00d4ff]/30 text-[#00d4ff] font-semibold font-inter mb-6" data-id="element-140">
            <ZapIcon className="w-5 h-5" data-id="element-141" />
            <span data-id="element-142">El Método del Apagón Sensorial</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-playfair font-bold mb-8 text-white leading-tight" data-id="element-143">
            Apaga el interruptor biológico <br className="hidden md:block" data-id="element-144" />{' '}
            del antojo
          </h2>
          <div className="text-lg md:text-xl text-[#a0a0b0] leading-relaxed font-inter max-w-3xl mx-auto space-y-6 text-left md:text-center" data-id="element-145">
            <p data-id="element-146">
              A diferencia de las dietas tradicionales, este protocolo utiliza
              la saturación mineral y el choque térmico para interrumpir la
              comunicación entre tus papilas gustativas y el centro de
              recompensa del cerebro.
            </p>
            <p data-id="element-147">
              Al usar{' '}
              <span className="text-[#f5a623] font-semibold" data-id="element-148">
                Magnesio Iónico
              </span>{' '}
              y estimulación de receptores amargos, obligamos al sistema
              nervioso a "reiniciar" su enfoque. No tienes que luchar contra el
              antojo; simplemente apagas el interruptor biológico que lo genera.
            </p>
          </div>
        </motion.div>

        {/* What You Get */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-gradient-to-b from-[#161622] to-[#0a0a0f] border border-[#00d4ff]/20 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(0,212,255,0.1)]" data-id="element-149">
          <h3 className="text-2xl md:text-3xl font-playfair font-bold mb-10 text-center text-white" data-id="element-150">
            Lo que recibes hoy:
          </h3>

          <ul className="space-y-6" data-id="element-151">
            {[{
            title: 'El Protocolo Adiós Azúcar',
            desc: '(Guía PDF Completa)'
          }, {
            title: 'El Método del Apagón Sensorial:',
            desc: 'La técnica de 30 segundos para detener un atracón.'
          }, {
            title: 'Lista de Compras de Emergencia:',
            desc: 'Los 3 minerales críticos que estabilizan tu insulina.'
          }, {
            title: 'Plan de Acción de 72 Horas:',
            desc: 'Qué comer y qué hacer desde la primera mañana hasta la libertad total.'
          }, {
            title: 'Guía de Gestión de "Gripe de Carbohidratos":',
            desc: 'Cómo evitar el dolor de cabeza y la irritabilidad.'
          }].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-[#00d4ff]/5 transition-colors border border-transparent hover:border-[#00d4ff]/10" data-id="element-152">
                <div className="mt-1 bg-[#00d4ff]/20 p-1 rounded-full shrink-0" data-id="element-153">
                  <CheckCircle2Icon className="w-6 h-6 text-[#00d4ff]" data-id="element-154" />
                </div>
                <div data-id="element-155">
                  <span className="text-white font-semibold text-lg font-inter block mb-1" data-id="element-156">
                    {item.title}
                  </span>
                  <span className="text-[#a0a0b0] font-inter" data-id="element-157">{item.desc}</span>
                </div>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}